'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _FolderClosedTwoTone = require('./lib/icons/FolderClosedTwoTone');
  
  
  var _default = _FolderClosedTwoTone;
  exports.default = _default;
  module.exports = _default;